import React, { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useStats } from './useStats';
import { AppStateTypes } from '../../store/appStateTypes';

export const StatsContainer: FC = () => {
  const { t, i18n } = useTranslation();
  const usersCounter = useSelector((state: AppStateTypes) => state.stats.usersCounter);
  const fontsCounter = useSelector((state: AppStateTypes) => state.stats.fontsCounter);
  const { loadStatsData } = useStats();

  useEffect(() => { loadStatsData(); }, []);

  const locale = i18n.language.startsWith('en') ? 'en' : 'ru';

  return (
    <div className="text-12 mb-16">
      <div>{t('stats.users').split('\n').map((line: string, i: number) => <span key={i}>{line}{i === 0 && <br />}</span>)} <span className="font-semibold">{usersCounter.toLocaleString(locale)}</span></div>
      -
      <div>{t('stats.fonts').split('\n').map((line: string, i: number) => <span key={i}>{line}{i === 0 && <br />}</span>)} <span className="font-semibold">{fontsCounter.toLocaleString(locale)}</span></div>
    </div>
  );
};
